// BlogSlider.jsx
import React, { useState } from 'react';
import './BlogSlider.css';

const blogPosts = [
  {
    category: 'Astrology',
    title: 'Vedic Astrology and the Importance of Ascendant',
    description:
      'Introduction to concept of Ascendant in Vedic Astrology. Have you ever wondered why some people seem to have it all figured out while others struggle to find their path?',
    author: 'Jyotish karmaa',
  },
  {
    category: 'Astrology',
    title: 'Vedic Astrology and Your Daily Horoscope Guide',
    description:
      'Introduction to Vedic and Western Astrology. Have you ever wondered about the cosmic forces that shape your life? Vedic and Western Astrology...',
    author: 'Jyotish karmaa',
  },
  {
    category: 'Astrology',
    title: 'Gemstones for Health and Wealth in 2025',
    description:
      'Explore the top gemstones believed to bring positive energy and protection in 2025, according to Vedic Astrology.',
    author: 'Jyotish karmaa',
  },
];

export default function BlogSlider() {
  const [current, setCurrent] = useState(0);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? blogPosts.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev === blogPosts.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="blog-slider-wrapper">
      <h2 className="blog-slider-title">Discover the Cosmos on Our Blog</h2>
      <div className="slider-content">
        <button className="nav-btn left" onClick={prevSlide}>
          ◀
        </button>
        <div className="blog-card">
          <span className="badge">{blogPosts[current].category}</span>
          <h3>{blogPosts[current].title}</h3>
          <p>{blogPosts[current].description}</p>
          <div className="author">– {blogPosts[current].author}</div>
        </div>
        <button className="nav-btn right" onClick={nextSlide}>
          ▶
        </button>
      </div>
      <div className="dots">
        {blogPosts.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? 'active' : ''}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}
